var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"invisible-button full-button_mb",on:{"click":_vm.exportCsv}},[_c('svg-download'),_vm._v(" Export tasks to CSV")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }